import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import Animate from '../../../../components/Animate';
import dataModel from '../../../../models/DataModel';
import './CompanyAddCard.scss';
import Input from '../../../../components/Input';

export class CompanyAddCard extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { companyName: '' };
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.inputField) {
      this.inputField.focus();
    }
  }

  handleAddCompany() {
    if (this.state.companyName) {
      const company = { name: this.state.companyName.trim(), notes: '', company_type: 2, custom_company_settings: [], location: { name: '', guid: '', address: '', city: '', state: '', zip: '', latitude: '', longitude: '' } };
      dataModel.companiesDAO.createCompany(company, { recordDescriptor: { company: { directories: {}, admin: {}, contact: {}, markets: {} } } }).then(newCompany => {
        if (newCompany) {
          
        }
        this.handleCancel();
      });
    }
    else {
      this.props.dataModel.displayInfoErrorMessage(this.textMap.companyNameRequired, 4000, 2);
    }
  }

  handleCancel() {
    this.setState({ closeCard: true });
  }

  handleChange(e) {
    this.setState({ companyName: e.target.value });
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleAddCompany();
    }
    else if (e.keyCode == 27) {
      this.handleCancel();
    }
  }

  handleClose() {
    if (this.props.closeAddCard) {
      this.props.closeAddCard();
    }
  }

  render() {

    return (

      // Replace with the appropriate HTML
      <div className="company-add-card" id={this.props.id}>
        <Animate key={'animate-add-in'} component_id={this.props.id} duration={250} property={{ height: { startVal: 0, endVal: 100 } }} />
        {this.state.closeCard && (
          <Animate key={'animate-add-out'} component_id={this.props.id} duration={250} property={{ height: { startVal: 100, endVal: 0 } }} completionCallback={this.handleClose} />
        )}
        <div className="add-company-box">
          <Input className="company-input" value={this.state.companyName} onChange={this.handleChange}
            placeholder={this.textMap.newCompany} onKeyDown={this.handleKeyDown} ref={(element) => {
              this.inputField = element;
            }}/>
        </div>
        <div className="add-button" data-qa="company-add-button"><span className="add-text" onClick={this.handleAddCompany}>{this.textMap.add.toUpperCase()}</span></div>
        <div className="cancel-button" onClick={this.handleCancel}/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CompanyAddCard);



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer/CompaniesNav/CompanyAddCard/index.js